import React, { type ReactNode } from 'react';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Link } from '@mentimeter/ragnar-ui/link';
import { useIsCurrentBrowserOutdated } from './hooks/useIsCurrentBrowserOutdated';

export function SupportedBrowsersOnly({
  children,
  fallback,
}: { children: ReactNode; fallback?: ReactNode }) {
  const isOutdatedBrowser = useIsCurrentBrowserOutdated();
  if (isOutdatedBrowser) {
    return (
      fallback || (
        <Text m="auto" p={6} textAlign="center">
          Hi, we&apos;re sorry to let you know that Mentimeter doesn&apos;t
          support your browser. Please
          <Link
            href="http://outdatedbrowser.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            update your browser
          </Link>
          , or try using another one.
        </Text>
      )
    );
  }
  return children;
}
